import React from "react";

const defaultSocialImpactData = [{ impact: "", action: "" }];

const SocialImpactActionTable = ({ socialImpactData, setSocialImpactData }) => {
  const handleChange = (index, field, value) => {
    const updated = [...socialImpactData];
    updated[index][field] = value;
    setSocialImpactData(updated);
  };

  const addRow = () => {
    setSocialImpactData([...socialImpactData, { impact: "", action: "" }]);
  };

  const removeRow = () => {
    if (socialImpactData.length > 1) {
      setSocialImpactData(socialImpactData.slice(0, -1));
    }
  };

  const cell = {
    border: "1px solid #000",
    padding: "15px",
    textAlign: "left",
    verticalAlign: "top",
  };

  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    textAlign: "center",
  };

  const inputStyle = {
    width: "100%",
    padding: "15px",
    border: "1px solid gray",
    borderRadius: "4px",
    fontSize: "14px",
  };

  return (
    <div>
      <div
        style={{
          overflowX: "auto",
          marginTop: 20,
          border: "1px solid #000",
          overflow: "hidden",
          borderRadius: "8px",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={header}>
                Details of negative social impact identified
              </th>
              <th style={header}>Corrective action plan</th>
            </tr>
          </thead>
          <tbody>
            {socialImpactData.map((row, index) => (
              <tr key={index}>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Details"
                    value={row.impact}
                    onChange={(e) =>
                      handleChange(index, "impact", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Details"
                    value={row.action}
                    onChange={(e) =>
                      handleChange(index, "action", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
          gap: "10px",
        }}
      >
        <button onClick={removeRow} style={removeButtonStyle}>
          - Remove
        </button>
        <button onClick={addRow} style={addButtonStyle}>
          + Add More
        </button>
      </div>
    </div>
  );
};

const addButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

const removeButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

export default SocialImpactActionTable;
